import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../common/services/common.service';

@Injectable()
export class ContactsService {


  constructor(private http: HttpClient, private _commonService: CommonService ) { }

  sendContactRequest(values){
    const params = {
      "Salutation":values.salutation,
      "FirstName":values.firstName,
      "LastName":values.lastName,
      "email":values.email,
      "Phone":values.phone,
      "BookingNumber":values.bookingnumber,
      "Description":values.ask
  }
    const headers: HttpHeaders = new HttpHeaders();
    return this.http.post(this._commonService.baseUrl + 'sendcontactrequest', params, { headers, observe: 'response' });
  }
}
